<script>
// Loader de la app móvil (LoaderContent en app-teamworkup): dos círculos que se
// cruzan y vuelven. Es el que usan Spinner, Loading e icon/Loading; el mismo
// componente está en linkiwork-intranet, con su color.
export default {
  name: "LoaderKaik",
  props: {
    // Dentro de un botón o junto a un texto: mide 0.75em de alto y toma el
    // color del texto (como el spinner-border de Bootstrap)
    enTexto: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <!-- El texto para lectores de pantalla lo pone quien lo usa (role="status") -->
  <svg
    class="loader-kaik"
    :class="{ 'loader-kaik--texto': enTexto }"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60 20"
    width="60"
    height="20"
    aria-hidden="true"
    focusable="false"
  >
    <circle class="loader-kaik__a" cx="10" cy="10" r="10" />
    <circle class="loader-kaik__b" cx="50" cy="10" r="10" />
  </svg>
</template>

<style scoped>
/*
 * Conversión del AnimationController de Flutter: 800 ms por tramo con
 * Curves.easeInOut (= cubic-bezier(0.42, 0, 0.58, 1)) y repeat(reverse: true)
 * (= alternate). Con size 20, cada círculo recorre 2 diámetros: de x=10 a x=50.
 * En SVG el translateX va en unidades del viewBox, así que vale a cualquier tamaño.
 */
.loader-kaik {
  display: block;
  /* Azul KÄIK, como en la app (en la intranet es el color de la empresa) */
  color: var(--color-kaik, #0037FF);
}

/*
 * Sin el shorthand "animation": su animation-name: none le ganaría a
 * .loader-kaik__a / __b, que con scoped tienen menos especificidad que este selector
 */
.loader-kaik circle {
  fill: currentColor;
  animation-duration: 0.8s;
  animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
  animation-iteration-count: infinite;
  animation-direction: alternate;
}

.loader-kaik__a {
  animation-name: loader-kaik-a;
}

.loader-kaik__b {
  animation-name: loader-kaik-b;
}

.loader-kaik--texto {
  display: inline-block;
  vertical-align: middle;
  width: 2.25em;
  height: 0.75em;
  color: inherit;
}

@keyframes loader-kaik-a {
  to {
    transform: translateX(40px);
  }
}

@keyframes loader-kaik-b {
  to {
    transform: translateX(-40px);
  }
}

/* Más lento, no quieto: detenido parecería que la página se colgó */
@media (prefers-reduced-motion: reduce) {
  .loader-kaik circle {
    animation-duration: 1.6s;
  }
}
</style>
